import { border } from '@atlaskit/adf-schema';
var borderPlugin = function borderPlugin() {
  return {
    name: 'border',
    marks: function marks() {
      return [{
        name: 'border',
        mark: border
      }];
    }
  };
};
export default borderPlugin;